import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useDeliveryTripItemListPdfHeader } from "./columnDef";
import { numberFormatter } from "utils/Formatter/Global";

export type GroupedServiceItem = {
  income_item_unique_id: string;
  income_item_name: string;
  qty: number;
  amount: number;
};

type Props = {
  itemList: GroupedServiceItem[];
  startNumber: number;
  lastTable: boolean;
  totalAmount: number;
};

const DeliveryTripItemListPdfTable = ({
  itemList,
  startNumber,
  lastTable,
  totalAmount,
}: Props) => {
  const headers = useDeliveryTripItemListPdfHeader();

  const tablePadding = {
    px: 1,
    py: 1,
    borderBottom: "none",
  };

  const fontSize = 10.66;

  const sxRow = (index: number) => {
    return lastTable && index === itemList.length - 1
      ? { borderBottom: "none" }
      : {};
  };

  return (
    <>
      <Box>
        <TableContainer
          sx={{
            border: `1px solid #d6cfcf`,
            borderBottom: "none",
            borderRadius: "5.33px",
            my: 1,
          }}
        >
          <Table
            sx={{
              tableLayout: "fixed",
              width: "100%",
            }}
            aria-label="simple table"
          >
            <TableHead sx={{ bgcolor: "#ECF6FD" }}>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell
                    align={header.align || "center"}
                    key={index}
                    sx={
                      index === headers.length - 1
                        ? { ...tablePadding, pr: 2 }
                        : tablePadding
                    }
                    width={header.width}
                  >
                    <Typography fontSize={fontSize} fontWeight={600}>
                      {header.thaiLabel}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {itemList.map((item, index) => (
                <TableRow
                  key={item.income_item_unique_id}
                  sx={{
                    verticalAlign: "top",
                    height: "32.52px",
                  }}
                >
                  <TableCell align="center" sx={sxRow(index)}>
                    <Typography fontSize={fontSize}>
                      {startNumber + index}
                    </Typography>
                  </TableCell>
                  <TableCell align="left" sx={sxRow(index)}>
                    <Typography fontSize={fontSize}>
                      {item.income_item_name}
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={sxRow(index)}>
                    <Typography fontSize={fontSize}>{item.qty}</Typography>
                  </TableCell>
                  <TableCell align="right" padding="none" sx={sxRow(index)}>
                    <Typography
                      fontSize={fontSize}
                      sx={{ wordBreak: "break-word", pr: 1 }}
                    >
                      {numberFormatter(item.amount)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {lastTable && (
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    bgcolor: "#ECF6FD",
                  }}
                >
                  <TableCell align="right" sx={{ pl: 50, pr: 5, py: 0.5 }}>
                    <Typography
                      fontSize={fontSize}
                      color={"#2167D3"}
                      fontWeight={600}
                    >
                      รวม
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ py: 0.5, pr: 0.5 }}>
                    <Typography
                      fontWeight={600}
                      fontSize={fontSize}
                      color={"#2167D3"}
                    >
                      {numberFormatter(totalAmount)}
                    </Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ py: 0.5, pl: 1.5, pr: 1.5 }}>
                    <Typography
                      fontWeight={600}
                      fontSize={fontSize}
                      color={"#2167D3"}
                    >
                      บาท
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          )}
        </TableContainer>
      </Box>
    </>
  );
};

export default DeliveryTripItemListPdfTable;
